// ดึงรายการเกม / เข้าเล่นเกม (ตรรกะเดียวกับ Starbet999 main.js: tabgamelist, tablauncher, tablauncherlotto)
import { isMobile } from 'react-device-detect';
import Swal from 'sweetalert2';
import instance from '../axios-instance';
import Systems from '../SystemFunction';
import { getStore, openLogin } from './store';
import { t } from './i18n';
import { getLang } from '../site/i18n';

// หมวดเกม -> state ของ /api/v1/tabgamelist (ตาม Starbet999)
export const CATEGORIES = {
  casino: { state: '2', game: 'casino', label: 'casino' },
  slot: { state: '3', game: 'slot', label: 'slot' },
  sport: { state: '5', game: 'sport', label: 'sport' },
  fishing: { state: '8', game: 'slot', label: 'fishing' },
  cards: { state: '11121', game: 'gamecard', label: 'card_game' },
  other: { state: '11131', game: 'export', label: 'mh_other_games' },
  lotto: { state: 'lotto', game: 'lotto', label: 'lotto' },
  demo: { state: '3', game: 'slot', label: 'mh_demo_title', demo: true },
};

const tr = (k) => t(getLang(), k);
const cache = new Map();
const TTL = 5 * 60 * 1000;

// แคช 2 ชั้น: หน่วยความจำ + localStorage (แสดงของเดิมทันที แล้วดึงของใหม่เบื้องหลัง)
async function cached(key, fn) {
  const hit = cache.get(key);
  if (hit && Date.now() - hit.ts < TTL) return hit.data;
  const lsKey = 'mh_cache_' + key;
  let stored = null;
  try { stored = JSON.parse(localStorage.getItem(lsKey)); } catch (e) { stored = null; }
  const refresh = fn().then((data) => {
    cache.set(key, { ts: Date.now(), data });
    try { localStorage.setItem(lsKey, JSON.stringify({ ts: Date.now(), data })); } catch (e) { /* เต็ม/ปิดไว้ */ }
    return data;
  });
  // [2026-10-19] เดิมโชว์ของเก่าใน localStorage ทุกครั้ง (หลังบ้านแก้รูป/ค่ายแล้วหน้าเว็บยังเห็นของเก่า)
  //   -> ใช้ของเก่าทันทีเฉพาะที่อายุไม่เกิน 60 วินาที ; เก่ากว่านั้นรอของใหม่ (ดึงไม่ได้ค่อยใช้ของเก่าสำรอง)
  const fresh = stored && Array.isArray(stored.data) && stored.data.length;
  if (fresh && Date.now() - Number(stored.ts || 0) < 60 * 1000) {
    cache.set(key, { ts: Number(stored.ts) || Date.now(), data: stored.data });
    refresh.catch(() => {});
    return stored.data;
  }
  if (fresh) return refresh.catch(() => stored.data);
  return refresh;
}

function playerid() {
  return getStore().user.username || null;
}

// รายชื่อค่ายเกมของหมวด
export function getProviders(category) {
  const c = CATEGORIES[category];
  if (!c) return Promise.resolve([]);
  const pid = playerid();
  return cached(`prov_${c.state}_${c.state === 'lotto' ? pid : ''}`, async () => {
    const body = { state: c.state, System: Systems };
    if (c.state === 'lotto') { body.playerid = pid; body.userid = pid; }
    const res = await instance.post('/api/v1/tabgamelist', body);
    return res.data.status === 200 && Array.isArray(res.data.message) ? res.data.message : [];
  });
}

// รายชื่อเกมของค่าย
export function getGames(category, partner) {
  const c = CATEGORIES[category] || CATEGORIES.slot;
  return cached(`games_${c.game}_${partner}`, async () => {
    const res = await instance.post('/api/v1/tabgamelist', { state: '999', System: Systems, partner, game: c.game });
    return res.data.status === 200 && Array.isArray(res.data.message) ? res.data.message : [];
  });
}

function openLauncher(launcher) {
  const ua = navigator.userAgent;
  if (/iPad|iPhone|Macintosh|iPod/.test(ua) && !window.MSStream) window.location.href = launcher.mobile;
  else if (isMobile) window.open(launcher.mobile);
  else window.open(launcher.desktop, '_blank', 'height=1000,width=1000');
}

function lockMessage(gamelock) {
  if (gamelock === 'slot' || gamelock === 'casino' || gamelock === 'sport') return tr('mh_game_lock_' + gamelock);
  return tr('mh_game_cannot_play');
}

// เข้าเล่นเกม (demo = ทดลองเล่น ไม่เสียเครดิต — หลังบ้านนี้ต้อง login ก่อนเหมือนเดิม)
export async function launchGame(gameId, partner, { demo = false } = {}) {
  const username = playerid();
  if (!username) {
    Swal.fire({ icon: 'warning', title: tr('login_first_title'), text: tr('login_first_play'), confirmButtonText: tr('ok') });
    openLogin();
    return;
  }
  try {
    const res = await instance.post('/api/v1/tablauncher', {
      gameId, partner, playerUsername: username, isMobile, System: Systems, demo,
    });
    if (res.data.status === 200 && res.data.message && res.data.message.launcher) {
      openLauncher(res.data.message.launcher);
    } else if (res.data.status === 200) {
      Swal.fire({ icon: 'error', title: tr('error'), text: tr('game_problem'), confirmButtonText: tr('ok') });
    } else if (res.data.gamelock) {
      Swal.fire({ icon: 'warning', title: tr('mh_notice'), text: lockMessage(res.data.gamelock), confirmButtonText: tr('ok') });
    } else {
      // [2026-10-31] ไม่ใช่ล็อกโปร → แสดงรหัสสาเหตุ + ข้อความจากค่ายเกม (ช่วยแอดมินไล่ปัญหา)
      const d = res.data || {};
      const pv = d.provider && d.provider.response;
      const pmsg = pv && (pv.message || pv.msg || pv.error || pv.description || (pv.data && (pv.data.message || pv.data.msg)));
      const code = [d.reason, d.provider && d.provider.http ? 'HTTP ' + d.provider.http : '', pmsg ? String(pmsg).slice(0, 120) : ''].filter(Boolean).join(' · ');
      Swal.fire({ icon: 'warning', title: tr('mh_notice'), html: tr('mh_game_cannot_play') + (code ? '<div style="margin-top:8px;font-size:12px;opacity:.7">(' + code.replace(/[<>&]/g, '') + ')</div>' : ''), confirmButtonText: tr('ok') });
    }
  } catch (e) {
    Swal.fire({ icon: 'error', title: tr('error'), text: tr('game_problem'), confirmButtonText: tr('ok') });
  }
}

// เข้าห้องหวย
export async function launchLotto(roomid) {
  const username = playerid();
  if (!username) {
    Swal.fire({ icon: 'warning', title: tr('login_first_title'), text: tr('login_first_play'), confirmButtonText: tr('ok') });
    openLogin();
    return;
  }
  try {
    const res = await instance.post('/api/v1/tablauncherlotto', { roomid, playerUsername: username, isMobile, System: Systems, demo: false });
    if (res.data.status === 200 && res.data.message && res.data.message.launcher) openLauncher(res.data.message.launcher);
    else Swal.fire({ icon: 'error', title: tr('error'), text: tr('game_problem'), confirmButtonText: tr('ok') });
  } catch (e) {
    Swal.fire({ icon: 'error', title: tr('error'), text: tr('game_problem'), confirmButtonText: tr('ok') });
  }
}
